<su-headline h="h1" skin="primary">{{ headline }}</su-headline>

<div style="width: fit-content">
  <su-button
    skin="primary"
    (click)="openSaleListingEditDialog('add')"
    [label]="'website_edit.label__create' | translate">
  </su-button>
</div>
<div class="parent-element">
  <form [formGroup]="searchform" class="search-container" id="searchForm">
    <mat-form-field class="formField">
      <mat-label>{{ 'website_edit.label__search' | translate }}</mat-label>
      <input
        matInput
        [formControl]="searchform.controls['searchTerm']"
        (keyup)="applySearch()"
        [matTooltip]="'website_edit.tooltip.search_help' | translate"
        matTooltipPosition="right" />
    </mat-form-field>
  </form>
</div>

<div>
  <ng-container>
    <mtx-grid
      id="saleListings"
      [columns]="columnsSaleListings"
      [data]="filteredSaleListingObjects"
      [loading]="isLoadingObjects"
      [columnResizable]="false"
      [rowStriped]="true"
      [showPaginator]="true"
      [pageSizeOptions]="[5, 10, 25, 50, 100]"
      [pageSize]="10"
      (rowClick)="onSelectSaleListing($event.rowData.id)">
    </mtx-grid>
  </ng-container>
</div>
<app-spinner-overlay [show]="isLoading"></app-spinner-overlay>
